let blinkInterval = null;
let originalTitle = document.title;

export function startBlinkingTitle(message = "🔔 업로드 완료!") {
    if (blinkInterval)
        return;

    window.addEventListener("focus", stopBlinkingTitle, { once: true });
    let toggle = false;
    blinkInterval = setInterval(() => {
        document.title = toggle ? message : originalTitle;
        toggle = !toggle;
    }, 1000);
}

export function stopBlinkingTitle() {
    if (!blinkInterval)
        return;

    clearInterval(blinkInterval);
    blinkInterval = null;
    document.title = originalTitle;
}